import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { FieldInput, TextAreaInput } from 'src/components';
import { ModalBox } from 'src/components/ModalContent/Modal';

interface CheckInCallNote {
    dateTime: string;
    subject: string;
    addedBy: string;
    id: string;
    body: string;
}

interface ViewCheckinCallModalProps {
    open: boolean;
    onClose: () => void;
    checkInCallNote: CheckInCallNote | null;
}

const FIELD_INPUT_BOX_STYLING = {
    style: {
        marginTop: '24px',
        width: '80%',
    },
};

export default function ViewCheckinCallModal({
    open,
    onClose,
    checkInCallNote,
}: ViewCheckinCallModalProps): JSX.Element | null {
    if (!checkInCallNote) return null;

    return (
        <ModalBox open={open} handleCloseModal={onClose} title="Check-in Call" widthSize="640px">
            <Formik
                initialValues={{
                    subject: checkInCallNote?.subject ?? '',
                    dateTime: checkInCallNote?.dateTime ?? '',
                    addedBy: checkInCallNote?.addedBy ?? '',
                    callNotes: checkInCallNote?.body ?? '',
                }}
                validationSchema={Yup.object().shape({})}
                onSubmit={() => {}}
            >
                <Box display="flex" flexDirection="column">
                    <FieldInput
                        type="text"
                        name="subject"
                        label="Subject"
                        placeholder="Enter subject"
                        disabled
                        boxStyling={FIELD_INPUT_BOX_STYLING}
                    />

                    <FieldInput
                        type="text"
                        name="dateTime"
                        label="Date/Time"
                        placeholder="Enter date/time"
                        disabled
                        boxStyling={FIELD_INPUT_BOX_STYLING}
                    />

                    <FieldInput
                        type="text"
                        name="addedBy"
                        label="Added By"
                        placeholder="Enter added by"
                        disabled
                        boxStyling={FIELD_INPUT_BOX_STYLING}
                    />

                    <Box display="flex" flexDirection="row" width="100%" marginTop={2}>
                        <Box display="flex" flexDirection="column" flex={1}>
                            <TextAreaInput
                                disabled
                                name="callNotes"
                                label="Call Notes"
                                placeholder="..."
                                inputStyle={{ style: { width: '100%' } }}
                            />
                        </Box>
                    </Box>

                    <Box display="flex" flexDirection="row" justifyContent="flex-end" mt={2}>
                        <Button variant="npi-primary" onClick={onClose} sx={{ width: '140px' }}>
                            Close
                        </Button>
                    </Box>
                </Box>
            </Formik>
        </ModalBox>
    );
}
